// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyCJcKmC52J2wggjOtQS33Mr6g2T4czMU8Y',
    authDomain: 'mindspace-adelaide.firebaseapp.com',
    projectId: 'mindspace-adelaide',
    storageBucket: 'mindspace-adelaide.appspot.com',
    messagingSenderId: '450901886755',
    appId: '1:450901886755:web:94794beeadd5a7e87c2e96',
    measurementId: 'G-9EJ5WSJRBH',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
